import { assertGradient, type GradientPaint } from "./gradient";
import type { SceneNode } from "../scene/model";
import { assertNativeAppearance, supportsAppearance } from "./appearance";

export type PaintChannel = "color" | "alpha" | "gradient";
/** A palette edits one channel; mixed colours and alpha values remain independent. */
export function changePaint(
  nodes: readonly SceneNode[],
  field: "fill" | "stroke",
  color: string,
  alpha: number,
  channel: PaintChannel,
  gradient?: GradientPaint | null,
) {
  return nodes
    .filter((n) => supportsAppearance(n, field))
    .map((node) => {
      const appearance = { ...node.appearance };
      if (channel === "gradient") {
        assertGradient(gradient);
        appearance[field + "Gradient"] = gradient;
      } else if (channel === "color") {
        appearance[field] = color;
        if (appearance[field + "Gradient"])
          appearance[field + "Gradient"] = null;
      } else {
        appearance[field === "fill" ? "fillAlpha" : "strokeAlpha"] = alpha;
        if (field === "fill") appearance.fillEnabled = true;
      }
      // Choosing paint activates an absent fill (including new closed pen paths).
      // Preserve each object's explicit alpha, including an intentional zero.
      if (field === "fill" && appearance.fillEnabled === false)
        appearance.fillEnabled = true;
      const changed = { ...node, appearance };
      assertNativeAppearance(changed);
      return changed;
    });
}
